export enum OrderCoursesEnum {
  InProgress = 0,
  finished = 1,
  avaliable = 2,
}
